var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugModes } from '../helpers/debug';
import { getStores, setGeolocationDataAsync } from '../helpers/localization';
const regionSelector = () => __awaiter(void 0, void 0, void 0, function* () {
    const regionBtns = document.querySelectorAll('[data-region-selector-btn]');
    const regionOverlay = document.querySelector('[data-region-selector-overlay]');
    const regionModal = document.querySelector('[data-region-selector]');
    const modalContainer = regionModal.querySelector('.region-selector-modal__container--inner');
    const closeBtn = regionModal.querySelector('#close-btn');
    const fileUrlFull = document.body.getAttribute('data-file-url');
    const fileUrlArr = fileUrlFull.split('?');
    const fileUrl = fileUrlArr[0];
    const openModal = () => {
        document.body.setAttribute('style', 'overflow: hidden');
        regionModal.classList.add('open');
        regionOverlay.classList.add('open');
    };
    const closeModal = () => {
        document.body.removeAttribute('style');
        regionOverlay.classList.remove('open');
        regionModal.classList.remove('open');
        regionModal.classList.add('closing');
        setTimeout(() => {
            regionModal.classList.remove('closing');
        }, 300);
    };
    closeBtn.addEventListener('click', closeModal);
    regionOverlay.addEventListener('click', closeModal);
    regionBtns.forEach((button) => {
        button.addEventListener('click', openModal);
    });
    let stores = [];
    if (window.thDebug.isEnabled(debugModes.geolocation)) {
        stores = getStores();
    }
    else {
        stores = getStores().filter((store) => store.enabled);
    }
    stores.forEach((store) => {
        const container = document.createElement('div');
        const title = document.createElement('h2');
        const form = document.createElement('form');
        container.setAttribute('class', 'region-selector-modal__region');
        title.innerText = store.name;
        form.setAttribute('class', 'region-selector-modal__region--list');
        form.setAttribute('method', 'post');
        form.setAttribute('action', `https://${store.primary_domain}/localization`);
        form.setAttribute('id', 'loalization-form-footer');
        form.innerHTML = `
      <input type="hidden" name="form_type" value="localization">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="_method" value="put">
      <input type="hidden" name="return_to" value="${`https://${store.primary_domain}/?m=1`}">
    `;
        store.availableCountries
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .forEach((country) => {
            const button = document.createElement('button');
            button.setAttribute('class', 'region-selector-modal__region--country-link');
            button.setAttribute('type', 'submit');
            button.setAttribute('name', 'country_code');
            button.setAttribute('value', country.isoCode);
            button.innerHTML = `
        <img class="flag-icon" width="25" height="18" src=${`https:${fileUrl}${country.isoCode}.png`} alt="${country.isoCode}" />
        <div class="country-name">
          <p>${country.name} (${country.currency.isoCode} ${country.currency.symbol})</p>
        </div>
      `;
            form.appendChild(button);
        });
        container.appendChild(title);
        container.appendChild(form);
        modalContainer.appendChild(container);
    });
});
(function () {
    return __awaiter(this, void 0, void 0, function* () {
        yield setGeolocationDataAsync();
        regionSelector();
    });
})();
